export default "__VITE_ASSET__D5QY8jpP__"